import { render, staticRenderFns } from "./DownloadModal.vue?vue&type=template&id=c8083094&scoped=true&"
import script from "./DownloadModal.vue?vue&type=script&lang=ts&"
export * from "./DownloadModal.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadModal.vue?vue&type=style&index=0&id=c8083094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8083094",
  null
  
)

export default component.exports